import { useContext, useState } from "react";
import * as tus from "tus-js-client";
import { Context } from "../../context";
import { Fetch, Post } from "../../fetch";
import { Progress, Space, message } from "antd";

const UploadVideo = (props) => {
  const { token, apiUrl, transcodeUrl, superAdmin } = useContext(Context);
  const [trailerUploading, setTrailerUploading] = useState(false);
  const [trailerUploadProgress, setTrailerUploadProgress] = useState(0);
  const [trailerExists, setTrailerExists] = useState(false);
  const [endpoint, setEndpoint] = useState("");

  const handleChange = async (e, type) => {
    let setUploadProgressFn;
    setTrailerUploading(true);
    setUploadProgressFn = setTrailerUploadProgress;

    console.log("FP uploaded start");
    const file = e.target.files[0];
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    var raw = JSON.stringify({
      content_id: props.content_id,
      content_type: props.content_type,
      content_title: props.content_title,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const response = await fetch(
      `${apiUrl}/video/getPresignedUrl`,
      requestOptions
    )
      .then((res) => res.json())
      .then((res) => {
        setEndpoint(res.presignedUrl);
        const uploadUrl = res.presignedUrl;
        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener("progress", (event) => {
          setTrailerUploading(true);
          if (event.lengthComputable) {
            const progress = Math.round((event.loaded / event.total) * 100);
            setUploadProgressFn(progress);
          }
        });

        xhr.onload = () => {
          Post(
            `${apiUrl}/video/submitJob`,
            token,
            {
              content_id: props.content_id,
              content_type: props.content_type,
              content_title: props.content_title,
            },
            (result) => {
              console.log(result);
            }
          );
        };

        xhr.open("PUT", uploadUrl, true);
        xhr.setRequestHeader("Content-Type", "multipart/form-data");
        xhr.send(file);
      });
  };

  return (
    <>
      <Space direction="horizontal">
        <input
          type="file"
          onChange={(e) => handleChange(e, "trailer")}
          accept="video/mp4"
        />
      </Space>
      {trailerUploadProgress ? (
        <Progress percent={trailerUploadProgress} />
      ) : null}
    </>
  );
};

export default UploadVideo;
